import LoginInputTitle from "./login-input-title";

export default { LoginInputTitle };
